"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonDates = exports.getMonthNumberByName = exports.dateAfterNow = exports.dateAfter = void 0;
const moment = require("moment");
const dateAfter = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);
    if (start.isValid() && end.isValid()) {
        if (start > end)
            return true;
        else
            return false;
    }
    else
        return -1;
};
exports.dateAfter = dateAfter;
const dateAfterNow = (date) => {
    const start = moment(date);
    const now = moment();
    if (start.isValid()) {
        if (start > now)
            return true;
        else
            return false;
    }
    else
        return -1;
};
exports.dateAfterNow = dateAfterNow;
const getMonthNumberByName = (monthName, locale) => {
    return moment()
        .locale(locale || 'es')
        .month(monthName)
        .format('M');
};
exports.getMonthNumberByName = getMonthNumberByName;
exports.BronsonDates = {
    dateAfter: exports.dateAfter,
    dateAfterNow: exports.dateAfterNow,
    getMonthNumberByName: exports.getMonthNumberByName,
};
